import { omit } from 'lodash';
import { generateKeys } from '../utils';
import { yesNo } from './general';
export const employmentStatuses = generateKeys({
    employed: {
        value: 'employed',
        label: 'Employed',
    },
    selfEmployed: {
        value: 'self-employed',
        label: 'Self Employed',
    },
    retired: {
        value: 'retired',
        label: 'Retired',
    },
    unemployed: {
        value: 'unemployed',
        label: 'Unemployed',
    },
    student: {
        value: 'student',
        label: 'Student',
    },
});
export const employerCategories = generateKeys({
    accountancy: {
        value: 'accountancy',
        label: 'Accountancy',
    },
    adminSecretarial: {
        value: 'admin_secretarial',
        label: 'Admin/Secretarial',
    },
    cateringHospitality: {
        value: 'catering_hospitality',
        label: 'Catering/Hospitality',
    },
    creativeMedia: {
        value: 'creative_media',
        label: 'Creative/Media',
    },
    education: {
        value: 'education',
        label: 'Education',
    },
    emergencyServices: {
        value: 'emergency_services',
        label: 'Emergency Services',
    },
    engineering: {
        value: 'engineering',
        label: 'Engineering',
    },
    financialServices: {
        value: 'financial_services',
        label: 'Financial Services',
    },
    healthMedicine: {
        value: 'health_medicine',
        label: 'Health / Medicine',
    },
    military: {
        value: 'military',
        label: 'Military',
    },
    humanResources: {
        value: 'human_resources',
        label: 'Human Resources',
    },
    insurance: {
        value: 'insurance',
        label: 'Insurance',
    },
    legal: {
        value: 'legal',
        label: 'Legal',
    },
    leisureTourism: {
        value: 'leisure_tourism',
        label: 'Leisure / Tourism',
    },
    manufacturing: {
        value: 'manufacturing',
        label: 'Manufacturing',
    },
    marketingPrAdvertising: {
        value: 'marketing_pr_advertising',
        label: 'Marketing / PR / Advertising',
    },
    pharmaceuticals: {
        value: 'pharmaceuticals',
        label: 'Pharmaceuticals',
    },
    constructionRealestate: {
        value: 'construction_realestate',
        label: 'Construction / Real Estate',
    },
    retail: {
        value: 'retail',
        label: 'Retail',
    },
    sales: {
        value: 'sales',
        label: 'Sales',
    },
    socialcareServices: {
        value: 'socialcare_services',
        label: 'Social Care / Services',
    },
    telecommunications: {
        value: 'telecommunications',
        label: 'Telecommunications',
    },
    transportLogistics: {
        value: 'transport_logistics',
        label: 'Transport / Logistics',
    },
    other: {
        value: 'other',
        label: 'Other',
    },
});
export const sourcesOfFunds = generateKeys({
    employment: {
        value: 'employment',
        label: 'Employment',
    },
    inheritance: {
        value: 'inheritance',
        label: 'Inheritance',
    },
    investment: {
        value: 'investment',
        label: 'Investment',
    },
    realestate: {
        value: 'realestate',
        label: 'Real Estate',
    },
    savings: {
        value: 'savings',
        label: 'Savings',
    },
    businessIncome: {
        value: 'business_income',
        label: 'Business income (please specify)',
    },
    assetSellingIncome: {
        value: 'asset_selling_income',
        label: 'Income from selling an asset (please specify)',
    },
    rentingPropertyIncome: {
        value: 'renting_property_income',
        label: 'Income from renting a property',
    },
    other: {
        value: 'other',
        label: 'Other (please specify)',
    },
});
const monetaryIntervals = generateKeys({
    none: {
        value: 'none',
        label: 'None',
    },
    lessThan20k: {
        value: 'less_than_20k',
        label: 'Less Than 20 thousands',
    },
    between20kAnd49k: {
        value: 'between_20k_and_49k',
        label: '20-49 (thousands)',
    },
    between50kAnd99k: {
        value: 'between_50k_and_99k',
        label: '50-99 (thousands)',
    },
    between100kAnd249k: {
        value: 'between_100k_and_249k',
        label: '100-249 (thousands)',
    },
    between250kAnd500k: {
        value: 'between_250k_and_500k',
        label: '250-500 (thousands)',
    },
    above500k: {
        value: 'above_500k',
        label: 'Above 500 (thousands)',
    },
});
export const expectedDeposits = omit(monetaryIntervals, 'none');
export const expectedTurnovers = omit(monetaryIntervals, 'none');
export const netWorths = monetaryIntervals;
export const annualIncomes = omit(monetaryIntervals, 'none');
export const tradingPurposes = generateKeys({
    strategicInvestment: {
        value: 'strategic_investment',
        label: 'Strategic investment',
    },
    tradingPurposes: {
        value: 'trading_purposes',
        label: 'Trading purposes',
    },
    profitability: {
        value: 'profitability',
        label: 'Profitability',
    },
    other: {
        value: 'other',
        label: 'Other (please specify)',
    },
});
export const experienceFrequencies = generateKeys({
    frequently: {
        value: 'frequently',
        label: 'Frequently',
    },
    sometimes: {
        value: 'sometimes',
        label: 'Sometimes',
    },
    rarelyNever: {
        value: 'rarely_never',
        label: 'Rarely / Never',
    },
});
export const experienceMethods = generateKeys({
    makeMyOwnDecisions: {
        value: 'make_my_own_decisions',
        label: 'I make my own trading decisions and/or take advice',
    },
    usedManagedFunds: {
        value: 'used_managed_funds',
        label: 'I used managed funds',
    },
});
export const avgTransactionSizes = generateKeys({
    lt10Eur: {
        value: 'lt_10_eur',
        label: '<10 EUR',
    },
    lt99Eur: {
        value: 'lt_99_eur',
        label: '<99 EUR',
    },
    lt499Eur: {
        value: 'lt_499_eur',
        label: '<499 EUR',
    },
    lt1000Eur: {
        value: 'lt_1000_eur',
        label: '<1000 EUR',
    },
    gt1000Eur: {
        value: 'gt_1000_eur',
        label: '>1000 EUR',
    },
});
export const legacyAppropTestQuestions = generateKeys({
    isUsReportable: {
        label: 'US Reportable',
        options: yesNo,
    },
    employmentStatus: {
        label: 'Employment Status',
        options: employmentStatuses,
    },
    employer: {
        label: 'Employer Name',
    },
    employerCategory: {
        label: 'Employer Category',
        options: employerCategories,
    },
    positionTitle: {
        label: 'Position Title',
    },
    sourceOfFunds: {
        label: 'Source of Funds',
        options: sourcesOfFunds,
    },
    sourceOfFundsOther: {
        label: 'Source of Funds Other',
    },
    annualIncome: {
        label: 'Annual Income',
        options: annualIncomes,
    },
    netWorth: {
        label: 'Net Worth',
        options: netWorths,
    },
    expectedDeposit: {
        label: 'Expected Deposit',
        options: expectedDeposits,
    },
    expectedTurnover: {
        label: 'Expected Turnover',
        options: expectedTurnovers,
    },
    avgTransactionSize: {
        label: 'Avg. Transaction Size',
        options: avgTransactionSizes,
    },
    tradingPurpose: {
        label: 'Trading Purpose',
        options: tradingPurposes,
    },
    tradingPurposeOther: {
        label: 'Trading Purpose Other',
    },
    isExperienced: {
        label: 'Is Experienced',
        options: yesNo,
    },
    experienceShares: {
        label: 'Experience - Shares',
        options: experienceFrequencies,
    },
    experienceExchange: {
        label: 'Experience - Exchange',
        options: experienceFrequencies,
    },
    experienceOtc: {
        label: 'Experience - OTC',
        options: experienceFrequencies,
    },
    experienceMethod: {
        label: 'Experience - Method',
        options: experienceMethods,
    },
});
